import { TermsOrGdprAndKioskResource } from './TermsOrGdprAndKioskResource'

export class TermsOrGdprResource {
    rid: number
    titleRo:string
    titleEn:string
    titleFr:string
    titleDe:string
    descriptionRo:string
    descriptionEn:string
    descriptionFr:string
    descriptionDe:string
    userEmail:string;
    terms:boolean
    errorCode: number;
    kioskResourceList: TermsOrGdprAndKioskResource[];
}